<script>
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [toasts],
  props: {
    category: Object,
  },
  data() {
    return {
      endpoint: "/api/library",
      modal: {
        fresh: true,
        active: false,
        modified: false,
        item: {
          name: null,
        },
      },
      messages: {
        remove: {
          title: "Удаление раздела",
          message: "Вы действительно хотите удалить данный раздел?",
          confirm: "Удалить раздел",
          cancel: "Отмена",
          success: "Раздел был успешно удален",
        },
      },
    };
  },
  methods: {
    redirect(url) {
      location.href = url;
    },
    open(item) {
      this.modal.fresh = item == null;
      if (item) {
        this.modal.item = JSON.parse(JSON.stringify(item));
      } else {
        this.modal.item = {
          name: null,
        };
      }
      this.modal.item.parent_id = _.get(this.category, "id");
      this.modal.active = true;
    },
    close() {
      this.modal.active = false;
    },
    save() {
      let item = this.modal.item;

      let loading = this.$loading.open();

      let request;

      if (this.modal.fresh) {
        request = axios.post(`${this.endpoint}`, item);
      } else {
        request = axios.put(`${this.endpoint}/${item.id}`, item);
      }

      request
        .then((response) => {
          axios
            .get(`${this.endpoint}`)
            .then((response) => {
              location.reload();
            })
            .catch((error) => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        })
        .catch((error) => {
          switch (error.response.status) {
            case 500: {
              this.toast("error", "@unexpected", error);
              break;
            }
            default: {
              this.toast("warning", error.response.data.error);
            }
          }
          loading.close();
        });
    },
    remove() {
      let item = this.modal.item;

      this.$dialog.confirm({
        title: this.messages.remove.title,
        message: this.messages.remove.message,
        confirmText: this.messages.remove.confirm,
        cancelText: this.messages.remove.cancel,
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`${this.endpoint}/${item.id}`)
            .then((response) => {
              // Redirect url to parent category
              location.href = response.data;
            })
            .catch((error) => {
              switch (error.response.status) {
                case 500: {
                  this.toast("error", "@unexpected", error);
                  break;
                }
                default: {
                  this.toast("error", error.response.data.error);
                }
              }
              loading.close();
            });
        },
      });
    },
  },
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/library/Index.vue